import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, inject } from '@angular/core';
import { Fridge } from 'src/app/models/Fridge';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../services/user/user.service';

type StatusFilter = 'all' | 'online' | 'offline';

@Component({
  selector: 'app-fridge-picker',
  templateUrl: './fridge-picker.component.html',
  styleUrls: ['./fridge-picker.component.scss'],
  standalone: false,
})
export class FridgePickerComponent implements OnInit, OnChanges {
  i18n = inject(TranslateService);
  private userService = inject(UserService);

  searchQuery = '';
  statusFilter: StatusFilter = 'all';
  offlineCollapsed = false;
  onlineList: Fridge[] = [];
  offlineList: Fridge[] = [];

  @Input() fridgeList: Fridge[];
  @Output() select: EventEmitter<string> = new EventEmitter();
  @Output() open: EventEmitter<void> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();

  @ViewChild('searchInput') searchInput: ElementRef;

  ngOnInit() {
    this.applyFilters();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fridgeList) {
      this.applyFilters();
    }
  }

  async openSearch() {
    this.open.emit();
  }

  async closeSearch() {
    this.close.emit();
  }

  setStatusFilter(filter: StatusFilter) {
    this.statusFilter = filter;
    this.applyFilters();
  }

  toggleOfflineGroup() {
    this.offlineCollapsed = !this.offlineCollapsed;
  }

  search(searchQuery: string) {
    this.searchQuery = searchQuery;
    this.applyFilters();
  }

  private applyFilters() {
    const s = (this.searchQuery || '').trim().toLowerCase().replace(/^#/, '');
    let list = this.fridgeList || [];

    if (s) {
      list = _.filter(list, (fridge) => {
        const merchant = this.userService.getMerchantById(fridge.merchantId as unknown as string);
        return (
          fridge.address.toLowerCase().includes(s) ||
          fridge.inventoryNumber.toString().includes(s) ||
          merchant.name.toLowerCase().includes(s)
        );
      });
    }

    this.onlineList = this.statusFilter === 'offline' ? [] : list.filter((f) => f.connected);
    this.offlineList = this.statusFilter === 'online' ? [] : list.filter((f) => !f.connected);
  }
}
